import {
  Autocomplete,
  AutocompleteProps,
  CircularProgress,
  TextField,
} from '@mui/material';
import { LoadState } from '../../../types/LoadState';

interface VarderingarAutocompleteCustomProps {
  loadState: LoadState;
  label: string;
  freeSolo?: boolean;
}

type VarderingarAutocompleteProps<T> = Partial<
  AutocompleteProps<T, false, true, boolean>
> &
  VarderingarAutocompleteCustomProps;

export const VarderingarAutocomplete = <T,>({
  disabled,
  options,
  filterOptions,
  inputValue,
  onInputChange,
  value,
  onChange,
  loadState,
  label,
  sx,
  getOptionLabel,
  isOptionEqualToValue,
  getOptionDisabled,
  freeSolo = true,
}: VarderingarAutocompleteProps<T>) => (
  <Autocomplete
    getOptionDisabled={
      getOptionDisabled ? (o) => getOptionDisabled(o) : (option) => !option
    }
    disabled={disabled}
    options={options}
    autoSelect
    autoHighlight
    autoComplete
    freeSolo={freeSolo}
    forcePopupIcon={false}
    filterOptions={filterOptions}
    sx={sx}
    size="small"
    inputValue={inputValue}
    onInputChange={onInputChange}
    value={value}
    onChange={onChange}
    getOptionLabel={getOptionLabel}
    isOptionEqualToValue={isOptionEqualToValue}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {loadState === LoadState.Loading ? (
                <CircularProgress sx={{ mr: 4 }} color="inherit" size={16} />
              ) : (
                <></>
              )}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    )}
  />
);
